import { useState, useEffect } from "react";
import PropTypes from "prop-types";

import PdfConfirmationModal from "../../LitigationPageModal/components/PdfConfirmationModal";
import UploadIcon from "../../../../public/bp_assets/img/cloud_icon.svg";
import incidentIcon from "../../../assets/images/incident.svg";
import birthdayIcon from "../../../assets/images/birthdayicon.svg";
import avatarImage from "../../../assets/images/avatar.svg";
import { api_without_cancellation } from "../../../api/api";
import { calculateAge, formatCalendarDate } from "../../../Utils/helper";
import mixColorWithWhite from "../../TreatmentPage/utils/helperFn";

import RequestDocModal from "./RequestDocModal";
import LinkDocToTaskModal from "./LinkDocToTaskModal";
import ChatDocumentModal from "./ChatDocumentModal";
// import DocumentRenameComponent from "./DocumentRenameComponent";
import CourtFormPageSideMenu from "./CourtFormPageSideMenu";
import "./GenerateCourtFormModalSideBar.css";

function toSentenceCase(str) {
  return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
}

function UserProfile({ clientInfo }) {
  return (
    <>
      <div
        className="user-profile-document-popup-img m-r-5 ic-15 d-flex align-items-center justify-content-center"
        style={{
          width: "15px",
          height: "15px",
        }}
      >
        {clientInfo?.profile_pic_29p ? (
          <img
            src={clientInfo.profile_pic_29p}
            alt="Client profile"
            style={{ width: "15px", height: "15px", borderRadius: "50%" }}
          />
        ) : (
          <img
            src={avatarImage}
            alt="Client profile"
            className="ic ic-avatar ic-15 has-avatar-icon d-flex align-items-center justify-content-center"
            style={{
              width: "15px",
              height: "15px",
              background: "var(--primary-30)",
              borderRadius: "50%",
            }}
          />
        )}
      </div>

      <span
        className="clientTabFont d-flex align-items-center height-25"
        style={{ fontSize: "14px", fontWeight: "600" }}
      >
        {clientInfo ? `${clientInfo.last_name} ${clientInfo.first_name}` : "Client Info"}
      </span>
    </>
  );
}

UserProfile.propTypes = {
  clientInfo: PropTypes.shape({
    profile_pic_29p: PropTypes.string,
    first_name: PropTypes.string,
    last_name: PropTypes.string,
  }),
};

function PageInfo({ _page, _documentSlot, _panel }) {
  // const { page_icon = "", name = "" } = page || {};

  return (
    <div
      className="d-flex flex-column"
      style={{
        height: "21px",
      }}
    >
      <div
        className="text-bold d-flex align-items-center"
        style={{
          height: "21px",
          fontWeight: "600",
          gap: "5px",
        }}
      >
        <span className="ic ic-15 ic-litigation" />
        Litigation
      </div>
    </div>
  );
}

PageInfo.propTypes = {
  page: PropTypes.shape({
    page_icon: PropTypes.string,
    name: PropTypes.string,
  }),
};

const GenerateCourtFormModalSideBar = ({
  docData,
  pages,
  slotsData,
  onRefetchSlotsData,
  loading,
  setSlotsData,
  refetchDocumentData,
  litigationId,
  _docId,
  fetchEditDocs,
  _type,
  container,
  docName,
  _state,
  _pageId,
  courtFormId,
  formDataContext,
  clientId,
  caseId,
  clientInfo,
  caseInfo,
  openCourtForm,
  showPdf,
  setShowPdf,
  isSaveDisabled,
}) => {
  const {
    id: docSideId,
    // for_client: clientInfo,
    // for_case: caseInfo,
    _file_name,
    attached_by: attachUser,
    document_slot: _documentSlot,
  } = docData || {};
  // const {
  //   // id: docSideId,
  //   // for_client: clientInfo,
  //   // for_case: caseInfo,
  //   // file_name,
  //   // attached_by: attachUser,
  //   // document_slot: _documentSlot,
  // } = documentData;

  const matchingSlot = slotsData?.find((slot) =>
    slot.page_docs?.some((doc) => doc.id === docData.id)
  );

  const matchExactSlott = matchingSlot?.page_docs?.find((doc) => doc.id === docData.id);

  const panelWithDocument = matchingSlot?.panels?.find((panel) =>
    panel.documents?.some((doc) => doc.id === docData?.id)
  );

  // const clientId = clientInfo?.id;
  // const caseId = caseInfo?.id;
  const userId = attachUser?.id ? attachUser.id : localStorage.getItem("loggedInUser") || null;

  const [showMenuBar, setShowMenuBar] = useState(false);
  const [panelMenuBar, setPanelMenuBar] = useState(false);

  const [showDocLinkModal, setShowDocLinkModal] = useState(false);
  const _handShowDocLinkModal = () => setShowDocLinkModal(true);
  const handleShowDocLinkModalClose = () => setShowDocLinkModal(false);

  const [showModal, setShowModal] = useState(false);
  const _handleShow = () => setShowModal(true);
  const handleClose = () => setShowModal(false);

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isPDFModalOpen, setIsPDFModalOpen] = useState(false);

  const toggleModal = () => setIsModalOpen(!isModalOpen);
  const togglePDFModal = () => setIsPDFModalOpen(!isPDFModalOpen);
  const [countdown, setCountdown] = useState(5);
  const [attachData, setAttachData] = useState(null);

  const redirectToFirmSetting = async () => {
    const redirect_url = "/bp-litigation/" + clientId + "/" + caseId;
    window.location.href = redirect_url;
  };

  useEffect(() => {
    if (isPDFModalOpen) {
      setCountdown(5);

      const timer = setTimeout(() => {
        redirectToFirmSetting();
      }, 5000);

      const countdownInterval = setInterval(() => {
        setCountdown((prev) => (prev > 0 ? prev - 1 : 0));
      }, 1000);

      return () => {
        clearTimeout(timer);
        clearInterval(countdownInterval);
      };
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isPDFModalOpen]);

  const [documentPanelsData, setDocumentPanelsData] = useState(null);
  const [width, setWidth] = useState(window.innerWidth);
  const [_height, setHeight] = useState(window.innerHeight);

  useEffect(() => {
    const handleResize = () => {
      setWidth(window.innerWidth);
      setHeight(window.innerHeight);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <div
      className="right-sidebar generate-court-form-sidebar d-flex flex-column justify-content-between"
      style={{ width: "280px", minWidth: "280px", zIndex: "1", height: "100%" }}
    >
      <div>
        <div>
          <div className="bluish-effect" />
          <div
            className="d-flex flex-column justify-content-between h-100"
            style={{ backgroundColor: "#f2f5f7" }}
          >
            <div className="top-content">
              <span
                className="color-main text-center text-color-heading d-flex align-items-center justify-content-center document-pop-up-menu-title"
                style={{ fontSize: "14px", height: "25px", borderRadius: "0px" }}
              >
                CASE
              </span>
              <div
                className="client-name d-flex align-items-center side-bar-padding"
                style={{ height: "21px", background: "var(--primary-2)" }}
              >
                <UserProfile clientInfo={clientInfo} />
              </div>
              <div
                className="tile-row w-100 p-l-5 p-r-5 d-flex align-items-center justify-content-between"
                style={{ height: "21px", background: "var(--primary-4)" }}
              >
                <div className="d-flex align-items-center" style={{ height: "21px" }}>
                  <span
                    className="ic-avatar ic-15 text-label color-grey-2 text-uppercase fw-bold d-flex align-items-center"
                    style={{ marginRight: "5px" }}
                  >
                    <img
                      src={birthdayIcon}
                      alt="Birthday"
                      style={{ width: "15px", height: "15px" }}
                    />
                  </span>
                  <p className="text-black font-weight-semibold d-block">
                    {formatCalendarDate(clientInfo?.birthday) || clientInfo?.birthday || ""}
                  </p>
                </div>
                <div className="d-flex align-items-center" style={{ height: "21px" }}>
                  <span
                    className="text-label fw-bold d-flex align-items-center"
                    style={{ marginRight: "5px", color: "var(--primary-25)", fontWeight: "600" }}
                  >
                    age
                  </span>
                  <p className="font-weight-semibold">{calculateAge(clientInfo?.birthday)}</p>
                </div>
              </div>
              <div
                className="tile-row w-100 p-l-5 p-r-5 d-flex flex-column align-items-start"
                style={{ height: "42px", background: "var(--primary-2)" }}
              >
                <div className="d-flex align-items-center" style={{ height: "21px" }}>
                  {caseInfo?.case_type?.casetype_icon && (
                    <span
                      className="ic-avatar ic-15 text-label color-grey-2 text-uppercase fw-bold d-flex align-items-center"
                      style={{ marginRight: "5px" }}
                    >
                      <img
                        src={caseInfo.case_type.casetype_icon}
                        alt="Case type"
                        style={{ width: "15px", height: "15px" }}
                      />
                    </span>
                  )}
                  <p className="text-black font-weight-semibold d-block">
                    {caseInfo?.case_type?.name || "N/A"}
                  </p>
                </div>
                <div className="d-flex align-items-center" style={{ height: "21px" }}>
                  <span
                    className="ic-avatar ic-15 text-label color-grey-2 text-uppercase fw-bold d-flex align-items-center"
                    style={{ marginRight: "5px" }}
                  >
                    <img
                      src={incidentIcon}
                      alt="Incident date"
                      style={{ width: "15px", height: "15px" }}
                    />
                  </span>
                  <p className="font-weight-semibold">
                    {formatCalendarDate(caseInfo?.incident_date) || "N/A"}
                  </p>
                </div>
              </div>

              <span
                className="color-main m-t-5 text-center text-color-heading d-flex align-items-center justify-content-center document-pop-up-menu-title"
                style={{ fontSize: "14px", height: "25px", borderRadius: "0px" }}
              >
                DOCUMENT NAME
              </span>
              <div
                className="generate-court-form-document-name d-flex align-items-center p-l-5 p-r-5"
                title={docName}
              >
                {docName || "Court Form Draft"}
              </div>

              <div className="basic-info m-r-0 m-l-0">
                <span
                  className="color-main m-t-5 text-center text-color-heading d-flex align-items-center justify-content-center document-pop-up-menu-title"
                  style={{ fontSize: "14px", height: "25px", borderRadius: "0px" }}
                >
                  LOCATION
                </span>
                <div
                  className="d-flex align-items-center justify-content-between m-b-0"
                  style={{ background: "white", height: "21px" }}
                >
                  <div
                    className="tile-row d-flex align-items-center justify-content-start flex-wrap w-100 p-l-5"
                    style={{
                      minHeight: "21px",
                      maxHeight: "21px",
                      overflow: "hidden",
                    }}
                  >
                    <PageInfo
                      page={matchingSlot?.page || {}}
                      documentSlot={matchExactSlott?.document_slot}
                      panel={panelWithDocument}
                    />
                  </div>
                </div>
              </div>
              {/* Hover Start */}
              <div className="">
                <span
                  className="color-main text-center text-color-heading d-flex align-items-center justify-content-center document-pop-up-menu-title"
                  style={{
                    fontSize: "14px",
                    height: "25px",
                    borderRadius: "0px",
                  }}
                >
                  {/* HOVER AND CLICK TO SAVE AS PDF TO: */}
                  CLICK TO SAVE FORM TO:
                </span>

                {loading ? (
                  <div>
                    <style>{`
               @keyframes shimmer {
                 0% {
                   background-position: -1000px 0;
                 }
                 100% {
                   background-position: 1000px 0;
                 }
               }
               .shimmer-effect {
                 animation: shimmer 2s infinite linear;
                 background: linear-gradient(
                   90deg,
                   transparent 0%,
                   rgba(255, 255, 255, 0.3) 50%,
                   transparent 100%
                 );
                 background-size: 1000px 100%;
               }
             `}</style>

                    <ul
                      className="generate-court-form-destinations document-pop-up-menu-sidebar"
                      style={{ paddingLeft: "0px" }}
                    >
                      {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14].map((index) => (
                        <li key={index} className="">
                          <a
                            className="cursor-pointer d-flex align-items-center shimmer-effect relative overflow-hidden"
                            style={{
                              height: "21px",
                              backgroundColor:
                                index % 2 === 0 ? "var(--primary-2)" : "var(--primary-4)",
                            }}
                          >
                            <div
                              className="absolute inset-0"
                              style={{
                                animation: "shimmer 2s infinite linear",
                                background:
                                  "linear-gradient(90deg, transparent 0%, rgba(255, 255, 255, 0.3) 50%, transparent 100%)",
                                backgroundSize: "1000px 100%",
                              }}
                            />
                          </a>
                        </li>
                      ))}
                    </ul>
                  </div>
                ) : (
                  <ul
                    className="generate-court-form-destinations document-pop-up-menu-sidebar"
                    style={{ paddingLeft: "0px" }}
                  >
                    {pages &&
                      pages.map((page, index) => {
                        // Find the corresponding slot data for the current page
                        const slotData = slotsData?.find((slot) => slot.page.name === page.name);

                        if (page.is_notes_category && slotData && slotData.page_slots.length > 0) {
                          const { panels, page_slots } = slotData;

                          // If panels exist, show panels first

                          // Treatment li
                          if (page_slots.length > 0 && page.name === "Treatment" && page.panels) {
                            return (
                              <li
                                key={index}
                                className=""
                                onMouseEnter={() => setShowMenuBar(index)}
                                onMouseLeave={() => setShowMenuBar(null)}
                                style={{
                                  position: "relative",
                                }}
                              >
                                <a
                                  className="cursor-pointer d-flex align-items-center"
                                  style={{
                                    gap: "5px",
                                    height: width > 2120 ? "21px" : "21px",
                                    fontWeight: "bold",
                                    paddingLeft: "5px",
                                  }}
                                >
                                  <img
                                    src={page.page_icon ?? ""}
                                    className="doc-pop-width-15px-height-15px"
                                    alt=""
                                  />
                                  {page.name}
                                  <span className="caret" />
                                </a>
                                <ul
                                  className="document-pop-up-sidebar-menubar"
                                  style={{
                                    position: "absolute",
                                    // left: "auto",
                                    top: "auto",
                                    // page.name === "Witnesses"
                                    //   ? `${index * 2 + 3}%`
                                    //   : "auto",
                                    left: "auto",
                                    minWidth: "auto",
                                    transform:
                                      width > 1920
                                        ? "translate(10px, -20px)"
                                        : "translate(10px, -20px)",
                                    right: "150px",
                                    display: showMenuBar === index ? "block" : "",
                                    width: "max-content",
                                    zIndex: 1,
                                  }}
                                >
                                  <li
                                    key={index}
                                    className="d-flex align-items-center justify-content-between background-white-hover-primary-four"
                                    style={{
                                      // background: "white",
                                      color: "var(--primary)",
                                      fontWeight: "600",
                                      fontSize: "14px",
                                      cursor: "pointer",
                                    }}
                                    onClick={async () => {
                                      const previousSlotData = slotsData;
                                      const slot = page_slots.find(
                                        (slot) => slot?.slot_number === 0
                                      );
                                      const updatedDocumentData = {
                                        ...docData,
                                        document_slot: slot ?? {},
                                      };

                                      const updatedSlotsData = slotsData.map((currentSlot) => {
                                        if (
                                          currentSlot?.page?.id === docData?.document_slot?.page?.id
                                        ) {
                                          const hasDocument = currentSlot.page_docs?.some(
                                            (doc) => doc.id === docData.id
                                          );
                                          const hasPanel = currentSlot.panels?.some((panel) =>
                                            panel.documents?.some((doc) => doc.id === docData.id)
                                          );

                                          if (hasDocument || hasPanel) {
                                            return {
                                              ...currentSlot,
                                              page_docs:
                                                currentSlot.page_docs?.filter(
                                                  (doc) => doc.id !== docData.id
                                                ) || [],
                                              panels:
                                                currentSlot.panels?.map((panel) => ({
                                                  ...panel,
                                                  documents:
                                                    panel.documents?.filter(
                                                      (doc) => doc.id !== docData.id
                                                    ) || [],
                                                })) || [],
                                            };
                                          }
                                        }

                                        return currentSlot;
                                      });

                                      const updatingSlot = updatedSlotsData.map((currentSlot) => {
                                        if (currentSlot?.page?.id === slot?.page?.id) {
                                          return {
                                            ...currentSlot,
                                            page_docs: [
                                              ...(currentSlot.page_docs || []),
                                              updatedDocumentData,
                                            ],
                                            panels:
                                              currentSlot.panels?.map((panel) => ({
                                                ...panel,
                                                documents: [
                                                  ...(panel.documents || []),
                                                  updatedDocumentData,
                                                ],
                                              })) || [],
                                          };
                                        }

                                        return currentSlot;
                                      });
                                      try {
                                        const formData = new FormData();
                                        formData.append("case_id", caseId);
                                        formData.append("client_id", clientId);
                                        formData.append("court_form_id", courtFormId);
                                        formData.append("context", JSON.stringify(formDataContext));

                                        const response = await api_without_cancellation.post(
                                          "api/court-form/generate-courtform-pdf/",
                                          formData,
                                          {
                                            headers: {
                                              "Content-Type": "multipart/form-data",
                                            },
                                          }
                                        );

                                        if (response.data) {
                                          setSlotsData(updatingSlot);
                                          const result = await api_without_cancellation.post(
                                            "api/doc/attach/",
                                            {
                                              panel_id: "",
                                              slot: page_slots.find(
                                                (slot) => slot.slot_number === 0
                                              ).id,
                                              page_id: page.id,
                                              case_id: caseId,
                                              panels: true,
                                              doc_id: response?.data?.doc_id,
                                            }
                                          );
                                          if (result.data) {
                                            setAttachData(result.data.docData);
                                            setIsPDFModalOpen(true);
                                          }
                                          if (typeof refetchDocumentData === "function") {
                                            await refetchDocumentData();
                                          }
                                          onRefetchSlotsData();
                                        }
                                      } catch (error) {
                                        console.error("Error attaching document to slot 0", error);
                                        setSlotsData(previousSlotData);
                                      }
                                    }}
                                  >
                                    <span
                                      className="d-flex align-items-center whitespace-nowrap "
                                      style={{
                                        fontWeight: "bold",
                                        paddingLeft: "25px",
                                      }}
                                    >
                                      <span
                                        className="m-r-5 d-flex align-items-center justify-content-center"
                                        style={{
                                          width: "25px",
                                          height: "25px",
                                        }}
                                      >
                                        <img
                                          src={page.page_icon ?? ""}
                                          className="document-icons-width d-flex align-items-center justify-content-center cursor-pointer"
                                          alt=""
                                        />
                                      </span>
                                      {page.name} Page
                                    </span>
                                    <span
                                      style={{
                                        display: "inline-block",
                                        width: "17px",
                                        height: "17px",
                                        color: "#19395F",
                                        transform: "rotate(180deg)",
                                        backgroundImage:
                                          showMenuBar === index
                                            ? "url(\"data:image/svg+xml,<svg width='17' height='17' viewBox='0 0 17 34' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M0.00634766 33.9993L0.00634766 24.7993L7.8602 16.9992L0.00634766 9.19912L0.00634766 -0.000884091L17.0063 16.9992L0.00634766 33.9993Z' fill='%2319395f'/></svg>%0A\")"
                                            : "",
                                        backgroundRepeat: "no-repeat",
                                        backgroundSize: "contain",
                                        // marginRight: "-10px",
                                      }}
                                    />
                                  </li>
                                  {page_slots.find((slot) => slot.slot_number === 0) && (
                                    <li
                                      className="d-flex align-items-center background-white-hover-primary-four"
                                      style={{
                                        // padding: "0px 10px",
                                        height: "25px",
                                        padding: "0 10px",
                                        // background: "white",
                                        cursor: "pointer",
                                        color: "var(--primary)",

                                        fontWeight: "600",
                                        fontSize: "14px",
                                        textTransform: "capitalize",
                                      }}
                                      onClick={async () => {
                                        const previousSlotData = slotsData;
                                        const slot = page_slots.find(
                                          (slot) => slot?.slot_number === 0
                                        );
                                        const updatedDocumentData = {
                                          ...docData,
                                          document_slot: slot ?? {},
                                        };

                                        const updatedSlotsData = slotsData.map((currentSlot) => {
                                          if (
                                            currentSlot?.page?.id ===
                                            docData?.document_slot?.page?.id
                                          ) {
                                            const hasDocument = currentSlot.page_docs?.some(
                                              (doc) => doc.id === docData.id
                                            );
                                            const hasPanel = currentSlot.panels?.some((panel) =>
                                              panel.documents?.some((doc) => doc.id === docData.id)
                                            );

                                            if (hasDocument || hasPanel) {
                                              return {
                                                ...currentSlot,
                                                page_docs:
                                                  currentSlot.page_docs?.filter(
                                                    (doc) => doc.id !== docData.id
                                                  ) || [],
                                                panels:
                                                  currentSlot.panels?.map((panel) => ({
                                                    ...panel,
                                                    documents:
                                                      panel.documents?.filter(
                                                        (doc) => doc.id !== docData.id
                                                      ) || [],
                                                  })) || [],
                                              };
                                            }
                                          }

                                          return currentSlot;
                                        });

                                        const updatingSlot = updatedSlotsData.map((currentSlot) => {
                                          if (currentSlot?.page?.id === slot?.page?.id) {
                                            return {
                                              ...currentSlot,
                                              page_docs: [
                                                ...(currentSlot.page_docs || []),
                                                updatedDocumentData,
                                              ],
                                              panels:
                                                currentSlot.panels?.map((panel) => ({
                                                  ...panel,
                                                  documents: [
                                                    ...(panel.documents || []),
                                                    updatedDocumentData,
                                                  ],
                                                })) || [],
                                            };
                                          }

                                          return currentSlot;
                                        });
                                        try {
                                          const formData = new FormData();
                                          formData.append("case_id", caseId);
                                          formData.append("client_id", clientId);
                                          formData.append("court_form_id", courtFormId);
                                          formData.append(
                                            "context",
                                            JSON.stringify(formDataContext)
                                          );

                                          const response = await api_without_cancellation.post(
                                            "api/court-form/generate-courtform-pdf/",
                                            formData,
                                            {
                                              headers: {
                                                "Content-Type": "multipart/form-data",
                                              },
                                            }
                                          );

                                          if (response.data) {
                                            setSlotsData(updatingSlot);
                                            const result = await api_without_cancellation.post(
                                              "api/doc/attach/",
                                              {
                                                panel_id: "",
                                                slot: page_slots.find(
                                                  (slot) => slot.slot_number === 0
                                                ).id,
                                                page_id: page.id,
                                                case_id: caseId,
                                                panels: true,
                                                doc_id: response?.data?.doc_id,
                                              }
                                            );
                                            if (result.data) {
                                              setAttachData(result.data.docData);
                                              setIsPDFModalOpen(true);
                                            }
                                            if (typeof refetchDocumentData === "function") {
                                              await refetchDocumentData();
                                            }
                                            onRefetchSlotsData();
                                          }
                                        } catch (error) {
                                          console.error(
                                            "Error attaching document to slot 0",
                                            error
                                          );
                                          setSlotsData(previousSlotData);
                                        }
                                      }}
                                    >
                                      <div
                                        className="d-flex align-items-center justify-content-center"
                                        style={{ width: "100%" }}
                                      >
                                        <span
                                          className="d-flex align-items-center whitespace-nowrap "
                                          style={{ fontWeight: "bold" }}
                                        >
                                          {/* <span
                                        className="m-r-5 d-flex align-items-center justify-content-center"
                                        style={{
                                          width: "25px",
                                          height: "25px",
                                        }}
                                      >
                                        <img
                                          src={page.page_icon ?? ""}
                                          className="document-icons-width d-flex align-items-center justify-content-center cursor-pointer"
                                          alt=""
                                        />
                                      </span> */}
                                          Attach to {page.name} Page
                                        </span>
                                      </div>
                                    </li>
                                  )}
                                  <li
                                    className="d-flex align-items-center"
                                    style={{
                                      // paddingLeft: "55px",
                                      height: "25px",
                                      padding: "0 10px",
                                      background: "var(--primary-15)",
                                    }}
                                  >
                                    <span
                                      className="d-flex align-items-center justify-content-center whitespace-nowrap"
                                      style={{
                                        fontWeight: "600",
                                        fontSize: "14px",
                                        color: "var(--primary)",
                                        width: "100%",
                                        textTransform: "uppercase",
                                      }}
                                    >
                                      {page?.panel_name}
                                    </span>
                                  </li>
                                  {panels?.length === 0 && (
                                    <li
                                      className="d-flex align-items-center"
                                      style={{
                                        // paddingLeft: "55px",
                                        height: "50px",
                                        padding: "0 10px",
                                        background: "var(--primary-2)",
                                      }}
                                    >
                                      <span
                                        className="d-flex align-items-center justify-content-center whitespace-nowrap"
                                        style={{
                                          fontWeight: "400",
                                          fontSize: "14px",
                                          color: "var(--primary-25)",
                                          width: "100%",
                                          // textTransform: "capitalize",
                                        }}
                                      >
                                        {toSentenceCase(`No ${page?.panel_name}`)}
                                      </span>
                                    </li>
                                  )}
                                  {panels.map((panel, panelIndex) => (
                                    <li
                                      key={panelIndex}
                                      className="d-flex align-items-center"
                                      style={{
                                        // padding: "0px 10px",
                                        height: "25px",
                                      }}
                                      onMouseEnter={() => {
                                        setDocumentPanelsData(panel);
                                        setPanelMenuBar(panelIndex);
                                      }}
                                      onMouseLeave={() => {
                                        setDocumentPanelsData([]);
                                        setPanelMenuBar(null);
                                      }}
                                    >
                                      <a
                                        className="cursor-pointer d-flex align-items-center color-grey-2"
                                        style={{ gap: "0px", width: "100%" }}
                                      >
                                        {/* <span
                                      style={{
                                        display: "inline-block",
                                        width: "17px",
                                        height: "17px",
                                        color: "#19395F",
                                        transform: "rotate(180deg)",
                                        backgroundImage:
                                          panelMenuBar === panelIndex
                                            ? `url("data:image/svg+xml,<svg width='17' height='17' viewBox='0 0 17 34' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M0.00634766 33.9993L0.00634766 24.7993L7.8602 16.9992L0.00634766 9.19912L0.00634766 -0.000884091L17.0063 16.9992L0.00634766 33.9993Z' fill='%2319395f'/></svg>%0A")`
                                            : "",
                                        backgroundRepeat: "no-repeat",
                                        backgroundSize: "contain",
                                      }}
                                    ></span> */}
                                        <span
                                          className=" d-flex align-items-center justify-content-center"
                                          style={{
                                            fontWeight: "bold",
                                            width: "25px",
                                            height: "25px",
                                          }}
                                        >
                                          {panelIndex + 1}
                                        </span>
                                        <span
                                          className="d-flex align-items-center p-r-5 whitespace-nowrap"
                                          style={{
                                            fontWeight: "600",
                                            fontSize: "14px",
                                            color: "black",
                                            width: "calc(100% - 25px)",
                                            background: mixColorWithWhite(
                                              panel?.specialty?.color,
                                              10
                                            ),
                                          }}
                                        >
                                          <span
                                            style={{
                                              background: panel?.specialty?.color,

                                              fontSize: "16px",
                                              fontWeight: "700",
                                              height: "25px",
                                              width: "25px",
                                              display: "flex",
                                              justifyContent: "center",
                                              alignItems: "center",
                                              color: "white",
                                              marginRight: "5px",
                                            }}
                                          >
                                            {panel?.specialty?.name[0] ?? ""}
                                          </span>
                                          {panel?.panel_name ? panel.panel_name : ""}
                                        </span>
                                      </a>
                                      <ul
                                        className="document-pop-up-sidebar-menubar"
                                        style={{
                                          position: "absolute",
                                          // left: "auto",
                                          top:
                                            width < 1920
                                              ? `${panelIndex * 2 + 18}%`
                                              : `${10 + panelIndex * 2}%`,
                                          left: "auto",
                                          // top: "auto",
                                          minWidth: "250px",
                                          transform:
                                            width > 1920
                                              ? `translate(10px, -${panelIndex + 15}%)`
                                              : `translate(10px, -${panelIndex + 30}%)`,
                                          // right: "17.2%",
                                          right: "91.2%",
                                          display: panelMenuBar === panelIndex ? "block" : "",
                                          width: "max-content",
                                        }}
                                      >
                                        <li
                                          className="d-flex align-items-center"
                                          style={{
                                            padding: "0px",
                                            height: "25px",
                                          }}
                                        >
                                          <span
                                            className="d-flex align-items-center whitespace-nowrap p-r-5"
                                            style={{
                                              fontWeight: "600",
                                              fontSize: "14px",
                                              color: "black",
                                              width: "100%",
                                              background: docData
                                                ? mixColorWithWhite(
                                                    documentPanelsData?.specialty?.color,
                                                    10
                                                  )
                                                : "",
                                            }}
                                          >
                                            <span
                                              style={{
                                                background: documentPanelsData?.specialty?.color,
                                                fontSize: "16px",
                                                fontWeight: "700",
                                                height: "25px",
                                                width: "25px",
                                                display: "flex",
                                                justifyContent: "center",
                                                alignItems: "center",
                                                color: "white",
                                                marginRight: "5px",
                                              }}
                                            >
                                              {documentPanelsData?.specialty?.name[0] ?? ""}
                                            </span>
                                            {documentPanelsData?.panel_name
                                              ? documentPanelsData.panel_name
                                              : ""}
                                          </span>
                                        </li>
                                        <li
                                          className="d-flex align-items-center"
                                          style={{
                                            paddingLeft: "55px",
                                            height: "25px",
                                            paddingRight: "10px",
                                            background: "var(--primary-15)",
                                          }}
                                        >
                                          <span
                                            className="d-flex align-items-center whitespace-nowrap p-r-5"
                                            style={{
                                              fontWeight: "600",
                                              fontSize: "14px",
                                              color: "var(--primary)",
                                              width: "100%",
                                              textTransform: "uppercase",
                                            }}
                                          >
                                            Document Row Buttons
                                          </span>
                                        </li>
                                        {page_slots.map((slot, slotIndex) => {
                                          const docsInSlot = panel.documents?.filter(
                                            (doc) =>
                                              doc.document_slot?.slot_number === slot?.slot_number
                                          );
                                          const handleClick = async () => {
                                            const previousSlotData = slotsData;
                                            const updatedDocumentData = {
                                              ...docData,
                                              document_slot: slot,
                                            };
                                            const matchingSlot = previousSlotData.find((slot) =>
                                              slot.page_docs?.some((doc) => doc.id === docData.id)
                                            );

                                            const panelWithDocument = matchingSlot?.panels?.find(
                                              (panel) =>
                                                panel.documents?.some(
                                                  (doc) => doc.id === docData?.id
                                                )
                                            );

                                            const updatedSlotsData = slotsData.map(
                                              (currentSlot) => {
                                                if (
                                                  currentSlot?.page?.id === matchingSlot?.page?.id
                                                ) {
                                                  const hasDocument = currentSlot.page_docs?.some(
                                                    (doc) => doc.id === docData.id
                                                  );
                                                  const hasPanel = currentSlot.panels?.some(
                                                    (panel) =>
                                                      panel.documents?.some(
                                                        (doc) => doc.id === docData.id
                                                      )
                                                  );

                                                  if (hasDocument || hasPanel) {
                                                    return {
                                                      ...currentSlot,
                                                      page_docs:
                                                        currentSlot.page_docs?.filter(
                                                          (doc) => doc.id !== docData.id
                                                        ) || [],

                                                      panels:
                                                        currentSlot.panels?.map((panel) => {
                                                          if (panel.id === panelWithDocument?.id) {
                                                            return {
                                                              ...panel,
                                                              documents: [
                                                                ...(panel.documents?.filter(
                                                                  (doc) => doc.id !== docData.id
                                                                ) || []),
                                                              ],
                                                            };
                                                          }
                                                          return panel;
                                                        }) || [],
                                                    };
                                                  }
                                                }

                                                return currentSlot;
                                              }
                                            );

                                            const updatingSlot = updatedSlotsData.map(
                                              (currentSlot) => {
                                                if (currentSlot?.page?.id === slot?.page?.id) {
                                                  return {
                                                    ...currentSlot,
                                                    page_docs: [
                                                      ...(currentSlot.page_docs || []),
                                                      updatedDocumentData,
                                                    ],
                                                    panels:
                                                      currentSlot.panels?.map((panel) => {
                                                        if (panel.id === documentPanelsData?.id) {
                                                          return {
                                                            ...panel,
                                                            documents: [
                                                              ...(panel.documents || []),
                                                              updatedDocumentData,
                                                            ],
                                                          };
                                                        }
                                                        return panel;
                                                      }) || [],
                                                  };
                                                }

                                                return currentSlot;
                                              }
                                            );

                                            try {
                                              const formData = new FormData();
                                              formData.append("case_id", caseId);
                                              formData.append("client_id", clientId);
                                              formData.append("court_form_id", courtFormId);
                                              formData.append(
                                                "context",
                                                JSON.stringify(formDataContext)
                                              );

                                              const response = await api_without_cancellation.post(
                                                "api/court-form/generate-courtform-pdf/",
                                                formData,
                                                {
                                                  headers: {
                                                    "Content-Type": "multipart/form-data",
                                                  },
                                                }
                                              );

                                              if (response.data) {
                                                setSlotsData(updatingSlot);
                                                const result = await api_without_cancellation.post(
                                                  "api/doc/attach/",
                                                  {
                                                    panel_id: panel.id,
                                                    slot: slot.id,
                                                    page_id: page.id,
                                                    case_id: caseId,
                                                    panels: true,
                                                    doc_id: response?.data?.doc_id,
                                                  }
                                                );
                                                if (result.data) {
                                                  setAttachData(result.data.docData);
                                                  setIsPDFModalOpen(true);
                                                }
                                                if (typeof refetchDocumentData === "function") {
                                                  await refetchDocumentData();
                                                }
                                                onRefetchSlotsData();
                                              }
                                            } catch (error) {
                                              console.error(error);
                                              setSlotsData(previousSlotData);
                                            }
                                          };

                                          return (
                                            slot.slot_number !== 0 && (
                                              <li
                                                key={slotIndex}
                                                className="d-flex align-items-center"
                                                style={{
                                                  padding: "0px 10px",
                                                  height: "25px",
                                                  background:
                                                    slotIndex % 2 === 0
                                                      ? mixColorWithWhite(
                                                          panel?.specialty?.color,
                                                          2
                                                        )
                                                      : mixColorWithWhite(
                                                          panel?.specialty?.color,
                                                          4
                                                        ),
                                                  cursor:
                                                    docsInSlot.length > 0 ? "default" : "pointer",
                                                }}
                                                onClick={handleClick}
                                              >
                                                {slot.slot_number !== 0 && (
                                                  <span className="d-flex align-items-center justify-content-center">
                                                    {docsInSlot.length > 0 ? (
                                                      <i
                                                        className="ic ic-19 ic-file-colored cursor-pointer document-icons-width"
                                                        style={{
                                                          backgroundRepeat: "no-repeat",
                                                        }}
                                                      />
                                                    ) : (
                                                      <img
                                                        src={UploadIcon}
                                                        className="document-icons-width cursor-pointer"
                                                        style={{
                                                          backgroundRepeat: "no-repeat",
                                                        }}
                                                      />
                                                    )}
                                                  </span>
                                                )}
                                                {/* 
                                        {slot.slot_number === 0 && (
                                          <span className="d-flex align-items-center ms-2">
                                            <img
                                              src={page.page_icon ?? ""}
                                              className="document-icons-width  cursor-pointer m-r-5"
                                              alt=""
                                            />
                                            Attach to {page.name} Page
                                          </span>
                                        )} */}

                                                {slot.slot_number !== 0 && (
                                                  <div
                                                    className={`d-flex align-items-center whitespace-nowrap  ${
                                                      docsInSlot.length === 0
                                                        ? "color-grey-2 hoverable-text"
                                                        : ""
                                                    }`}
                                                    style={{
                                                      width: "calc(100% - 25px)",
                                                      fontWeight: "bold",
                                                      // height: "25px",
                                                    }}
                                                  >
                                                    <>
                                                      <span className="ms-2 hoverable-text">
                                                        {slot.slot_number}.
                                                      </span>
                                                      <span className="ms-2 hoverable-text">
                                                        {docsInSlot.length > 0
                                                          ? docsInSlot[0].file_name
                                                          : slot.slot_name
                                                            ? slot.slot_name
                                                            : "Available"}
                                                      </span>
                                                    </>
                                                  </div>
                                                )}
                                              </li>
                                            )
                                          );
                                        })}
                                      </ul>
                                    </li>
                                  ))}
                                </ul>
                              </li>
                            );
                          }

                          // Wage Loss, Reports,   Def, Witnesses, Parties, Insurance, Loans, Costs,   Litigation, Discovery, Exports
                          if (page_slots.length > 0 && page.panels) {
                            return (
                              <li
                                key={index}
                                className=""
                                onMouseEnter={() => setShowMenuBar(index)}
                                onMouseLeave={() => setShowMenuBar(null)}
                                style={{
                                  position: "relative",
                                }}
                              >
                                <a
                                  className="cursor-pointer d-flex align-items-center"
                                  style={{
                                    gap: "5px",
                                    height: width > 2120 ? "21px" : "21px",
                                    fontWeight: "bold",
                                    paddingLeft: "5px",
                                  }}
                                >
                                  {/* <span
                                style={{
                                  display: "inline-block",
                                  width: "17px",
                                  height: "17px",
                                  color: "#19395F",
                                  transform: "rotate(180deg)",
                                  backgroundImage:
                                    showMenuBar === index
                                      ? `url("data:image/svg+xml,<svg width='17' height='17' viewBox='0 0 17 34' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M0.00634766 33.9993L0.00634766 24.7993L7.8602 16.9992L0.00634766 9.19912L0.00634766 -0.000884091L17.0063 16.9992L0.00634766 33.9993Z' fill='%2319395f'/></svg>%0A")`
                                      : "",
                                  backgroundRepeat: "no-repeat",
                                  backgroundSize: "contain",
                                }}
                              ></span> */}
                                  <img
                                    src={page.page_icon ?? ""}
                                    className="doc-pop-width-15px-height-15px"
                                    alt=""
                                  />
                                  {page.name}
                                  <span className="caret" />
                                </a>
                                <ul
                                  className="document-pop-up-sidebar-menubar"
                                  style={{
                                    position: "absolute",
                                    // left: "auto",
                                    top: "auto",
                                    // page.name === "Witnesses"
                                    //   ? `${index * 2 + 3}%`
                                    //   : "auto",
                                    left: "auto",
                                    minWidth: "auto",
                                    transform:
                                      width > 1920
                                        ? "translate(10px, -20px)"
                                        : "translate(10px, -20px)",
                                    right: "150px",
                                    display: showMenuBar === index ? "block" : "",
                                    width: "max-content",
                                    zIndex: 1,
                                  }}
                                >
                                  <li
                                    key={index}
                                    className="d-flex align-items-center justify-content-between background-white-hover-primary-four"
                                    style={{
                                      // background: "white",
                                      color: "var(--primary)",
                                      fontWeight: "600",
                                      fontSize: "14px",
                                      padding: "0 10px",
                                      cursor: "pointer",
                                    }}
                                    onClick={async () => {
                                      const previousSlotData = slotsData;
                                      const slot = page_slots.find(
                                        (slot) => slot?.slot_number === 0
                                      );
                                      const updatedDocumentData = {
                                        ...docData,
                                        document_slot: slot ?? {},
                                      };

                                      const updatedSlotsData = slotsData.map((currentSlot) => {
                                        if (
                                          currentSlot?.page?.id === docData?.document_slot?.page?.id
                                        ) {
                                          const hasDocument = currentSlot.page_docs?.some(
                                            (doc) => doc.id === docData.id
                                          );
                                          const hasPanel = currentSlot.panels?.some((panel) =>
                                            panel.documents?.some((doc) => doc.id === docData.id)
                                          );

                                          if (hasDocument || hasPanel) {
                                            return {
                                              ...currentSlot,
                                              page_docs:
                                                currentSlot.page_docs?.filter(
                                                  (doc) => doc.id !== docData.id
                                                ) || [],
                                              panels:
                                                currentSlot.panels?.map((panel) => ({
                                                  ...panel,
                                                  documents:
                                                    panel.documents?.filter(
                                                      (doc) => doc.id !== docData.id
                                                    ) || [],
                                                })) || [],
                                            };
                                          }
                                        }

                                        return currentSlot;
                                      });

                                      const updatingSlot = updatedSlotsData.map((currentSlot) => {
                                        if (currentSlot?.page?.id === slot?.page?.id) {
                                          return {
                                            ...currentSlot,
                                            page_docs: [
                                              ...(currentSlot.page_docs || []),
                                              updatedDocumentData,
                                            ],
                                            panels:
                                              currentSlot.panels?.map((panel) => ({
                                                ...panel,
                                                documents: [
                                                  ...(panel.documents || []),
                                                  updatedDocumentData,
                                                ],
                                              })) || [],
                                          };
                                        }

                                        return currentSlot;
                                      });
                                      try {
                                        const formData = new FormData();
                                        formData.append("case_id", caseId);
                                        formData.append("client_id", clientId);
                                        formData.append("court_form_id", courtFormId);
                                        formData.append("context", JSON.stringify(formDataContext));

                                        const response = await api_without_cancellation.post(
                                          "api/court-form/generate-courtform-pdf/",
                                          formData,
                                          {
                                            headers: {
                                              "Content-Type": "multipart/form-data",
                                            },
                                          }
                                        );

                                        if (response.data) {
                                          setSlotsData(updatingSlot);
                                          const result = await api_without_cancellation.post(
                                            "api/doc/attach/",
                                            {
                                              panel_id: "",
                                              slot: page_slots.find(
                                                (slot) => slot.slot_number === 0
                                              ).id,
                                              page_id: page.id,
                                              case_id: caseId,
                                              panels: true,
                                              doc_id: response?.data?.doc_id,
                                            }
                                          );
                                          if (result.data) {
                                            setAttachData(result.data.docData);
                                            setIsPDFModalOpen(true);
                                          }
                                          if (typeof refetchDocumentData === "function") {
                                            await refetchDocumentData();
                                          }
                                          onRefetchSlotsData();
                                        }
                                      } catch (error) {
                                        console.error("Error attaching document to slot 0", error);
                                        setSlotsData(previousSlotData);
                                      }
                                    }}
                                  >
                                    <span
                                      className="cursor-pointer d-flex align-items-center"
                                      style={{
                                        gap: "5px",
                                        fontWeight: "bold",

                                        height: "25px",
                                      }}
                                    >
                                      <img
                                        src={page.page_icon ?? ""}
                                        className="doc-pop-width-15px-height-15px"
                                        alt=""
                                      />
                                      {page.name} Page
                                    </span>
                                    <span
                                      style={{
                                        display: "inline-block",
                                        width: "17px",
                                        height: "17px",
                                        color: "#19395F",
                                        transform: "rotate(180deg)",
                                        backgroundImage:
                                          showMenuBar === index
                                            ? "url(\"data:image/svg+xml,<svg width='17' height='17' viewBox='0 0 17 34' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M0.00634766 33.9993L0.00634766 24.7993L7.8602 16.9992L0.00634766 9.19912L0.00634766 -0.000884091L17.0063 16.9992L0.00634766 33.9993Z' fill='%2319395f'/></svg>%0A\")"
                                            : "",
                                        backgroundRepeat: "no-repeat",
                                        backgroundSize: "contain",
                                        marginRight: "-10px",
                                      }}
                                    />
                                  </li>
                                  {page_slots.find((slot) => slot.slot_number === 0) && (
                                    <li
                                      className="d-flex align-items-center background-white-hover-primary-four"
                                      style={{
                                        padding: "0px 10px",
                                        height: "25px",
                                        cursor: "pointer",
                                        // background: "white",

                                        color: "var(--primary)",

                                        fontWeight: "600",
                                        fontSize: "14px",
                                        textTransform: "capitalize",
                                      }}
                                      onClick={async () => {
                                        const previousSlotData = slotsData;
                                        const slot = page_slots.find(
                                          (slot) => slot?.slot_number === 0
                                        );
                                        const updatedDocumentData = {
                                          ...docData,
                                          document_slot: slot ?? {},
                                        };

                                        const updatedSlotsData = slotsData.map((currentSlot) => {
                                          if (
                                            currentSlot?.page?.id ===
                                            docData?.document_slot?.page?.id
                                          ) {
                                            const hasDocument = currentSlot.page_docs?.some(
                                              (doc) => doc.id === docData.id
                                            );
                                            const hasPanel = currentSlot.panels?.some((panel) =>
                                              panel.documents?.some((doc) => doc.id === docData.id)
                                            );

                                            if (hasDocument || hasPanel) {
                                              return {
                                                ...currentSlot,
                                                page_docs:
                                                  currentSlot.page_docs?.filter(
                                                    (doc) => doc.id !== docData.id
                                                  ) || [],
                                                panels:
                                                  currentSlot.panels?.map((panel) => ({
                                                    ...panel,
                                                    documents:
                                                      panel.documents?.filter(
                                                        (doc) => doc.id !== docData.id
                                                      ) || [],
                                                  })) || [],
                                              };
                                            }
                                          }

                                          return currentSlot;
                                        });

                                        const updatingSlot = updatedSlotsData.map((currentSlot) => {
                                          if (currentSlot?.page?.id === slot?.page?.id) {
                                            return {
                                              ...currentSlot,
                                              page_docs: [
                                                ...(currentSlot.page_docs || []),
                                                updatedDocumentData,
                                              ],
                                              panels:
                                                currentSlot.panels?.map((panel) => ({
                                                  ...panel,
                                                  documents: [
                                                    ...(panel.documents || []),
                                                    updatedDocumentData,
                                                  ],
                                                })) || [],
                                            };
                                          }

                                          return currentSlot;
                                        });
                                        try {
                                          const formData = new FormData();
                                          formData.append("case_id", caseId);
                                          formData.append("client_id", clientId);
                                          formData.append("court_form_id", courtFormId);
                                          formData.append(
                                            "context",
                                            JSON.stringify(formDataContext)
                                          );

                                          const response = await api_without_cancellation.post(
                                            "api/court-form/generate-courtform-pdf/",
                                            formData,
                                            {
                                              headers: {
                                                "Content-Type": "multipart/form-data",
                                              },
                                            }
                                          );

                                          if (response.data) {
                                            setSlotsData(updatingSlot);
                                            const result = await api_without_cancellation.post(
                                              "api/doc/attach/",
                                              {
                                                panel_id: "",
                                                slot: page_slots.find(
                                                  (slot) => slot.slot_number === 0
                                                ).id,
                                                page_id: page.id,
                                                case_id: caseId,
                                                panels: true,
                                                doc_id: response?.data?.doc_id,
                                              }
                                            );
                                            if (result.data) {
                                              setAttachData(result.data.docData);
                                              setIsPDFModalOpen(true);
                                            }
                                            if (typeof refetchDocumentData === "function") {
                                              await refetchDocumentData();
                                            }
                                            onRefetchSlotsData();
                                          }
                                        } catch (error) {
                                          console.error(
                                            "Error attaching document to slot 0",
                                            error
                                          );
                                          setSlotsData(previousSlotData);
                                        }
                                      }}
                                    >
                                      <div
                                        className="d-flex align-items-center justify-content-center"
                                        style={{ width: "100%" }}
                                      >
                                        <span
                                          className="d-flex align-items-center whitespace-nowrap "
                                          style={{ fontWeight: "bold" }}
                                        >
                                          {/* <img
                                        src={page.page_icon ?? ""}
                                        className="document-icons-width cursor-pointer m-r-5"
                                        alt=""
                                      /> */}
                                          Attach to {page.name} Page
                                        </span>
                                      </div>
                                    </li>
                                  )}
                                  <li
                                    className="d-flex align-items-center"
                                    style={{
                                      // paddingLeft: "55px",
                                      height: "25px",
                                      padding: "0 10px",
                                      background: "var(--primary-15)",
                                    }}
                                  >
                                    <span
                                      className="d-flex align-items-center justify-content-center whitespace-nowrap"
                                      style={{
                                        fontWeight: "600",
                                        fontSize: "14px",
                                        color: "var(--primary)",
                                        width: "100%",
                                        textTransform: "uppercase",
                                      }}
                                    >
                                      {page?.panel_name}
                                    </span>
                                  </li>
                                  {panels?.length === 0 && (
                                    <li
                                      className="d-flex align-items-center"
                                      style={{
                                        // paddingLeft: "55px",
                                        height: "50px",
                                        padding: "0 10px",
                                        background: "var(--primary-2)",
                                      }}
                                    >
                                      <span
                                        className="d-flex align-items-center justify-content-center whitespace-nowrap"
                                        style={{
                                          fontWeight: "400",
                                          fontSize: "14px",
                                          color: "var(--primary-25)",
                                          width: "100%",
                                          // textTransform: "",
                                        }}
                                      >
                                        {toSentenceCase(`No ${page?.panel_name}`)}
                                      </span>
                                    </li>
                                  )}
                                  {panels.map((panel, panelIndex) => (
                                    <li
                                      key={panelIndex}
                                      className="d-flex align-items-center"
                                      style={{
                                        // padding: "0px 10px",
                                        height: "25px",
                                      }}
                                      onMouseEnter={() => {
                                        setDocumentPanelsData(panel);
                                        setPanelMenuBar(panelIndex);
                                      }}
                                      onMouseLeave={() => {
                                        setDocumentPanelsData([]);
                                        setPanelMenuBar(null);
                                      }}
                                    >
                                      <a
                                        className="cursor-pointer d-flex align-items-center color-grey-2"
                                        // style={{ gap: "5px" }}
                                      >
                                        <span
                                          style={{
                                            display: "inline-block",
                                            width: "17px",
                                            height: "17px",
                                            color: "#19395F",
                                            transform: "rotate(180deg)",
                                            backgroundImage:
                                              panelMenuBar === panelIndex
                                                ? "url(\"data:image/svg+xml,<svg width='17' height='17' viewBox='0 0 17 34' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M0.00634766 33.9993L0.00634766 24.7993L7.8602 16.9992L0.00634766 9.19912L0.00634766 -0.000884091L17.0063 16.9992L0.00634766 33.9993Z' fill='%2319395f'/></svg>%0A\")"
                                                : "",
                                            backgroundRepeat: "no-repeat",
                                            backgroundSize: "contain",
                                          }}
                                        />
                                        <span className="ms-2" style={{ fontWeight: "bold" }}>
                                          {panelIndex + 1}.
                                        </span>
                                        <span
                                          className="ms-2 whitespace-nowrap"
                                          style={{
                                            fontWeight: "bold",
                                            color: "var(--primary)",
                                          }}
                                        >
                                          {page?.name === "Offer" ? panel?.panel_name : ""}
                                          {page?.name !== "Offer"
                                            ? panel?.specialty
                                              ? panel?.specialty.name
                                              : panel?.panel_name
                                                ? panel?.panel_name
                                                : ""
                                            : ""}
                                        </span>
                                      </a>
                                      <ul
                                        className="document-pop-up-sidebar-menubar"
                                        style={{
                                          position: "absolute",
                                          // left: "auto",
                                          top:
                                            width < 1920
                                              ? `${panelIndex * 2 + 18}%`
                                              : `${10 + panelIndex * 2}%`,
                                          left: "auto",
                                          // top: "auto",
                                          minWidth: "auto",
                                          transform:
                                            width > 1920
                                              ? `translate(10px, -${panelIndex + 15}%)`
                                              : `translate(10px, -${panelIndex + 30}%)`,
                                          // right: "17.2%",
                                          right: "91.2%",
                                          display: panelMenuBar === panelIndex ? "block" : "",
                                          width: "max-content",
                                        }}
                                      >
                                        <li
                                          className="d-flex align-items-center"
                                          style={{
                                            padding: "0px",
                                            height: "25px",
                                          }}
                                        >
                                          <span
                                            className="d-flex align-items-center whitespace-nowrap p-r-5"
                                            style={{
                                              fontWeight: "600",
                                              fontSize: "14px",
                                              color: "black",
                                              width: "100%",
                                            }}
                                          >
                                            <span
                                              style={{
                                                fontSize: "16px",
                                                fontWeight: "700",
                                                height: "25px",
                                                width: "25px",
                                                display: "flex",
                                                justifyContent: "center",
                                                alignItems: "center",
                                                color: "black",
                                                marginRight: "5px",
                                              }}
                                            >
                                              1.
                                            </span>
                                            {documentPanelsData?.panel_name
                                              ? documentPanelsData.panel_name
                                              : ""}
                                          </span>
                                        </li>
                                        <li
                                          className="d-flex align-items-center"
                                          style={{
                                            paddingLeft: "55px",
                                            height: "25px",
                                            paddingRight: "10px",
                                            background: "var(--primary-15)",
                                          }}
                                        >
                                          <span
                                            className="d-flex align-items-center whitespace-nowrap p-r-5"
                                            style={{
                                              fontWeight: "600",
                                              fontSize: "14px",
                                              color: "var(--primary)",
                                              width: "100%",
                                              textTransform: "uppercase",
                                            }}
                                          >
                                            Document Row Buttons
                                          </span>
                                        </li>
                                        {page_slots.map((slot, slotIndex) => {
                                          const docsInSlot = panel.documents?.filter(
                                            (doc) =>
                                              doc.document_slot?.slot_number === slot?.slot_number
                                          );
                                          const handleClick = async () => {
                                            const previousSlotData = slotsData;
                                            const updatedDocumentData = {
                                              ...docData,
                                              document_slot: slot,
                                            };
                                            const matchingSlot = previousSlotData.find((slot) =>
                                              slot.page_docs?.some((doc) => doc.id === docData.id)
                                            );

                                            const panelWithDocument = matchingSlot?.panels?.find(
                                              (panel) =>
                                                panel.documents?.some(
                                                  (doc) => doc.id === docData?.id
                                                )
                                            );

                                            const updatedSlotsData = slotsData.map(
                                              (currentSlot) => {
                                                if (
                                                  currentSlot?.page?.id === matchingSlot?.page?.id
                                                ) {
                                                  const hasDocument = currentSlot.page_docs?.some(
                                                    (doc) => doc.id === docData.id
                                                  );
                                                  const hasPanel = currentSlot.panels?.some(
                                                    (panel) =>
                                                      panel.documents?.some(
                                                        (doc) => doc.id === docData.id
                                                      )
                                                  );

                                                  if (hasDocument || hasPanel) {
                                                    return {
                                                      ...currentSlot,
                                                      page_docs:
                                                        currentSlot.page_docs?.filter(
                                                          (doc) => doc.id !== docData.id
                                                        ) || [],
                                                      panels:
                                                        currentSlot.panels?.map((panel) => {
                                                          if (panel.id === panelWithDocument?.id) {
                                                            return {
                                                              ...panel,
                                                              documents: [
                                                                ...(panel.documents?.filter(
                                                                  (doc) => doc.id !== docData.id
                                                                ) || []),
                                                              ],
                                                            };
                                                          }
                                                          return panel;
                                                        }) || [],
                                                    };
                                                  }
                                                }

                                                return currentSlot;
                                              }
                                            );

                                            const updatingSlot = updatedSlotsData.map(
                                              (currentSlot) => {
                                                if (currentSlot?.page?.id === slot?.page?.id) {
                                                  return {
                                                    ...currentSlot,
                                                    page_docs: [
                                                      ...(currentSlot.page_docs || []),
                                                      updatedDocumentData,
                                                    ],
                                                    panels:
                                                      currentSlot.panels?.map((panel) => {
                                                        if (panel.id === documentPanelsData?.id) {
                                                          return {
                                                            ...panel,
                                                            documents: [
                                                              ...(panel.documents || []),
                                                              updatedDocumentData,
                                                            ],
                                                          };
                                                        }
                                                        return panel;
                                                      }) || [],
                                                  };
                                                }

                                                return currentSlot;
                                              }
                                            );

                                            try {
                                              const formData = new FormData();
                                              formData.append("case_id", caseId);
                                              formData.append("client_id", clientId);
                                              formData.append("court_form_id", courtFormId);
                                              formData.append(
                                                "context",
                                                JSON.stringify(formDataContext)
                                              );

                                              const response = await api_without_cancellation.post(
                                                "api/court-form/generate-courtform-pdf/",
                                                formData,
                                                {
                                                  headers: {
                                                    "Content-Type": "multipart/form-data",
                                                  },
                                                }
                                              );

                                              if (response.data) {
                                                setSlotsData(updatingSlot);
                                                const result = await api_without_cancellation.post(
                                                  "api/doc/attach/",
                                                  {
                                                    panel_id: panel.id,
                                                    slot: slot.id,
                                                    page_id: page.id,
                                                    case_id: caseId,
                                                    panels: true,
                                                    doc_id: response?.data?.doc_id,
                                                  }
                                                );
                                                if (result.data) {
                                                  setAttachData(result.data.docData);
                                                  setIsPDFModalOpen(true);
                                                }
                                                if (typeof refetchDocumentData === "function") {
                                                  await refetchDocumentData();
                                                }
                                                onRefetchSlotsData();
                                              }
                                            } catch (error) {
                                              console.error(error);
                                              setSlotsData(previousSlotData);
                                            }
                                          };

                                          return (
                                            slot.slot_number !== 0 && (
                                              <li
                                                key={slotIndex}
                                                className="d-flex align-items-center"
                                                style={{
                                                  padding: "0px 10px",
                                                  height: "25px",
                                                  cursor:
                                                    docsInSlot.length > 0 ? "default" : "pointer",
                                                }}
                                                onClick={handleClick}
                                              >
                                                {slot.slot_number !== 0 && (
                                                  <span className="d-flex align-items-center justify-content-center">
                                                    {docsInSlot.length > 0 ? (
                                                      <i
                                                        className="ic ic-19 ic-file-colored cursor-pointer document-icons-width"
                                                        style={{
                                                          backgroundRepeat: "no-repeat",
                                                        }}
                                                      />
                                                    ) : (
                                                      <img
                                                        src={UploadIcon}
                                                        className="document-icons-width cursor-pointer"
                                                        style={{
                                                          backgroundRepeat: "no-repeat",
                                                        }}
                                                      />
                                                    )}
                                                  </span>
                                                )}
                                                {/* 
                                        {slot.slot_number === 0 && (
                                          <span className="d-flex align-items-center ms-2">
                                            <img
                                              src={page.page_icon ?? ""}
                                              className="document-icons-width  cursor-pointer m-r-5"
                                              alt=""
                                            />
                                            Attach to {page.name} Page
                                          </span>
                                        )} */}

                                                {slot.slot_number !== 0 && (
                                                  <div
                                                    className={`d-flex align-items-center  ${
                                                      docsInSlot.length === 0
                                                        ? "color-grey-2 hoverable-text"
                                                        : ""
                                                    }`}
                                                    style={{
                                                      width: "calc(100% - 25px)",
                                                      fontWeight: "bold",
                                                      // height: "25px",
                                                    }}
                                                  >
                                                    <>
                                                      <span className="ms-2 hoverable-text">
                                                        {slot.slot_number}.
                                                      </span>
                                                      <span className="ms-2 hoverable-text whitespace-nowrap">
                                                        {docsInSlot.length > 0
                                                          ? docsInSlot[0].file_name
                                                          : slot.slot_name
                                                            ? slot.slot_name
                                                            : "Available"}
                                                      </span>
                                                    </>
                                                  </div>
                                                )}
                                              </li>
                                            )
                                          );
                                        })}
                                      </ul>
                                    </li>
                                  ))}
                                </ul>
                              </li>
                            );
                          }

                          // If no panels, show page slots directly
                          // Case, Client, Accident, Injury, Settle
                          if (page_slots.length > 0 && !page.panels) {
                            return (
                              <li
                                key={index}
                                className=""
                                onMouseEnter={() => setShowMenuBar(index)}
                                onMouseLeave={() => setShowMenuBar(null)}
                                style={{
                                  position: "relative",
                                }}
                              >
                                <a
                                  className="cursor-pointer d-flex align-items-center"
                                  style={{
                                    gap: "5px",
                                    height: width > 2120 ? "21px" : "21px",
                                    fontWeight: "bold",
                                    paddingLeft: "5px",
                                  }}
                                >
                                  <img
                                    src={page.page_icon ?? ""}
                                    className="doc-pop-width-15px-height-15px"
                                    alt=""
                                  />
                                  {page.name}
                                  <span className="caret" />
                                </a>
                                <ul
                                  className="document-pop-up-sidebar-menubar"
                                  style={{
                                    position: "absolute",
                                    // left: "auto",
                                    // top:
                                    //   width < 1920
                                    //     ? `${index * 2 + 30}%`
                                    //     : `${10 + index * 1.5}%`,
                                    left: "auto",
                                    top: "auto",
                                    minWidth: "auto",
                                    transform:
                                      width > 1920
                                        ? "translate(10px, -20px)"
                                        : "translate(10px, -20px)",
                                    right: "150px",
                                    display: showMenuBar === index ? "block" : "",
                                    width: "max-content",
                                    zIndex: 1,
                                  }}
                                >
                                  <li
                                    key={index}
                                    className="d-flex align-items-center justify-content-between background-white-hover-primary-four"
                                    style={{
                                      // background: "white",
                                      color: "var(--primary)",
                                      fontWeight: "600",
                                      fontSize: "14px",
                                      padding: "0 10px",
                                      cursor: "pointer",
                                    }}
                                    onClick={async () => {
                                      const previousSlotData = slotsData;
                                      const slot = page_slots.find(
                                        (slot) => slot?.slot_number === 0
                                      );

                                      const updatedDocumentData = {
                                        ...docData,
                                        document_slot: slot,
                                      };

                                      const matchingSlot = previousSlotData.find((slot) =>
                                        slot.page_docs?.some((doc) => doc.id === docData.id)
                                      );

                                      const panelWithDocument = matchingSlot?.panels?.find(
                                        (panel) =>
                                          panel.documents?.some((doc) => doc.id === docData?.id)
                                      );

                                      const updatedSlotsData = slotsData.map((currentSlot) => {
                                        if (currentSlot?.page?.id === matchingSlot?.page?.id) {
                                          const hasDocument = currentSlot.page_docs?.some(
                                            (doc) => doc.id === docData.id
                                          );

                                          const hasPanel = currentSlot.panels?.some((panel) =>
                                            panel.documents?.some((doc) => doc.id === docData.id)
                                          );

                                          if (hasPanel) {
                                            return {
                                              ...currentSlot,
                                              page_docs:
                                                currentSlot.page_docs?.filter(
                                                  (doc) => doc.id !== docData.id
                                                ) || [],
                                              panels:
                                                currentSlot.panels?.map((panel) => {
                                                  if (panel.id === panelWithDocument?.id) {
                                                    return {
                                                      ...panel,
                                                      documents: [
                                                        ...(panel.documents?.filter(
                                                          (doc) => doc.id !== docData.id
                                                        ) || []),
                                                      ],
                                                    };
                                                  }
                                                  return panel;
                                                }) || [],
                                            };
                                          } else if (hasDocument) {
                                            const filteredDocs = currentSlot.page_docs.filter(
                                              (doc) => doc.id !== docData.id
                                            );

                                            return {
                                              ...currentSlot,
                                              page_docs: filteredDocs,
                                            };
                                          }
                                        }

                                        return currentSlot;
                                      });

                                      const updatingSlot = updatedSlotsData.map((currentSlot) => {
                                        if (currentSlot?.page?.id === slot?.page?.id) {
                                          return {
                                            ...currentSlot,
                                            page_docs: currentSlot.page_docs
                                              ? [...currentSlot.page_docs, updatedDocumentData]
                                              : [updatedDocumentData],
                                          };
                                        }

                                        return currentSlot;
                                      });

                                      try {
                                        const formData = new FormData();
                                        formData.append("case_id", caseId);
                                        formData.append("client_id", clientId);
                                        formData.append("court_form_id", courtFormId);
                                        formData.append("context", JSON.stringify(formDataContext));

                                        const response = await api_without_cancellation.post(
                                          "api/court-form/generate-courtform-pdf/",
                                          formData,
                                          {
                                            headers: {
                                              "Content-Type": "multipart/form-data",
                                            },
                                          }
                                        );

                                        if (response.data) {
                                          setSlotsData(updatingSlot);
                                          const result = await api_without_cancellation.post(
                                            "api/doc/attach/",
                                            {
                                              slot: slot.id,
                                              page_id: page.id,
                                              case_id: caseId,
                                              panels: false,
                                              doc_id: response?.data?.doc_id,
                                            }
                                          );
                                          if (result.data) {
                                            setAttachData(result.data.docData);
                                            setIsPDFModalOpen(true);
                                          }
                                          if (typeof refetchDocumentData === "function") {
                                            await refetchDocumentData();
                                          }
                                          onRefetchSlotsData();
                                        }
                                      } catch (error) {
                                        console.error(error);
                                        setSlotsData(previousSlotData);
                                      }
                                    }}
                                  >
                                    <span
                                      className="cursor-pointer d-flex align-items-center"
                                      style={{
                                        gap: "5px",
                                        fontWeight: "bold",
                                        // paddingLeft: "10px",
                                        height: "25px",
                                      }}
                                    >
                                      <img
                                        src={page.page_icon ?? ""}
                                        className="doc-pop-width-15px-height-15px"
                                        alt=""
                                      />
                                      {page.name} Page
                                    </span>
                                    <span
                                      style={{
                                        display: "inline-block",
                                        width: "17px",
                                        height: "17px",
                                        color: "#19395F",
                                        transform: "rotate(180deg)",
                                        backgroundImage:
                                          showMenuBar === index
                                            ? "url(\"data:image/svg+xml,<svg width='17' height='17' viewBox='0 0 17 34' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M0.00634766 33.9993L0.00634766 24.7993L7.8602 16.9992L0.00634766 9.19912L0.00634766 -0.000884091L17.0063 16.9992L0.00634766 33.9993Z' fill='%2319395f'/></svg>%0A\")"
                                            : "",
                                        backgroundRepeat: "no-repeat",
                                        backgroundSize: "contain",
                                        marginRight: "-10px",
                                      }}
                                    />
                                  </li>
                                  {page_slots.find((slot) => slot.slot_number === 0) && (
                                    <li
                                      className="d-flex align-items-center background-white-hover-primary-four"
                                      style={{
                                        padding: "0px 10px",
                                        height: "25px",
                                        cursor: "pointer",
                                        // background: "white",

                                        color: "var(--primary)",

                                        fontWeight: "600",
                                        fontSize: "14px",
                                        textTransform: "capitalize",
                                      }}
                                      onClick={async () => {
                                        const previousSlotData = slotsData;
                                        const slot = page_slots.find(
                                          (slot) => slot?.slot_number === 0
                                        );

                                        const updatedDocumentData = {
                                          ...docData,
                                          document_slot: slot,
                                        };

                                        const matchingSlot = previousSlotData.find((slot) =>
                                          slot.page_docs?.some((doc) => doc.id === docData.id)
                                        );

                                        const panelWithDocument = matchingSlot?.panels?.find(
                                          (panel) =>
                                            panel.documents?.some((doc) => doc.id === docData?.id)
                                        );

                                        const updatedSlotsData = slotsData.map((currentSlot) => {
                                          if (currentSlot?.page?.id === matchingSlot?.page?.id) {
                                            const hasDocument = currentSlot.page_docs?.some(
                                              (doc) => doc.id === docData.id
                                            );

                                            const hasPanel = currentSlot.panels?.some((panel) =>
                                              panel.documents?.some((doc) => doc.id === docData.id)
                                            );

                                            if (hasPanel) {
                                              return {
                                                ...currentSlot,
                                                page_docs:
                                                  currentSlot.page_docs?.filter(
                                                    (doc) => doc.id !== docData.id
                                                  ) || [],
                                                panels:
                                                  currentSlot.panels?.map((panel) => {
                                                    if (panel.id === panelWithDocument?.id) {
                                                      return {
                                                        ...panel,
                                                        documents: [
                                                          ...(panel.documents?.filter(
                                                            (doc) => doc.id !== docData.id
                                                          ) || []),
                                                        ],
                                                      };
                                                    }
                                                    return panel;
                                                  }) || [],
                                              };
                                            } else if (hasDocument) {
                                              const filteredDocs = currentSlot.page_docs.filter(
                                                (doc) => doc.id !== docData.id
                                              );

                                              return {
                                                ...currentSlot,
                                                page_docs: filteredDocs,
                                              };
                                            }
                                          }

                                          return currentSlot;
                                        });

                                        const updatingSlot = updatedSlotsData.map((currentSlot) => {
                                          if (currentSlot?.page?.id === slot?.page?.id) {
                                            return {
                                              ...currentSlot,
                                              page_docs: currentSlot.page_docs
                                                ? [...currentSlot.page_docs, updatedDocumentData]
                                                : [updatedDocumentData],
                                            };
                                          }

                                          return currentSlot;
                                        });

                                        try {
                                          const formData = new FormData();
                                          formData.append("case_id", caseId);
                                          formData.append("client_id", clientId);
                                          formData.append("court_form_id", courtFormId);
                                          formData.append(
                                            "context",
                                            JSON.stringify(formDataContext)
                                          );

                                          const response = await api_without_cancellation.post(
                                            "api/court-form/generate-courtform-pdf/",
                                            formData,
                                            {
                                              headers: {
                                                "Content-Type": "multipart/form-data",
                                              },
                                            }
                                          );

                                          if (response.data) {
                                            setSlotsData(updatingSlot);
                                            const result = await api_without_cancellation.post(
                                              "api/doc/attach/",
                                              {
                                                slot: slot.id,
                                                page_id: page.id,
                                                case_id: caseId,
                                                panels: false,
                                                doc_id: response?.data?.doc_id,
                                              }
                                            );
                                            if (result.data) {
                                              setAttachData(result.data.docData);
                                              setIsPDFModalOpen(true);
                                            }
                                            if (typeof refetchDocumentData === "function") {
                                              await refetchDocumentData();
                                            }
                                            onRefetchSlotsData();
                                          }
                                        } catch (error) {
                                          console.error(error);
                                          setSlotsData(previousSlotData);
                                        }
                                      }}
                                    >
                                      <div
                                        className="d-flex align-items-center justify-content-center"
                                        style={{ width: "100%" }}
                                      >
                                        <span
                                          className="d-flex align-items-center whitespace-nowrap "
                                          style={{ fontWeight: "bold" }}
                                        >
                                          {/* <img
                                        src={page.page_icon ?? ""}
                                        className="document-icons-width cursor-pointer m-r-5"
                                        alt=""
                                      /> */}
                                          Attach to {page.name} Page
                                        </span>
                                      </div>
                                    </li>
                                  )}

                                  <li
                                    className="d-flex align-items-center"
                                    style={{
                                      paddingLeft: "55px",
                                      height: "25px",
                                      paddingRight: "10px",
                                      background: "var(--primary-15)",
                                    }}
                                  >
                                    <span
                                      className="d-flex align-items-center whitespace-nowrap p-r-5"
                                      style={{
                                        fontWeight: "600",
                                        fontSize: "14px",
                                        color: "var(--primary)",
                                        width: "100%",
                                        textTransform: "uppercase",
                                      }}
                                    >
                                      Document Row Buttons
                                    </span>
                                  </li>

                                  {page_slots
                                    .filter((slot) => slot.slot_number !== 0)
                                    .map((slot, slotIndex) => {
                                      const docsInSlot = slotData.page_docs?.filter(
                                        (doc) =>
                                          doc.document_slot?.slot_number === slot?.slot_number
                                      );

                                      const handleClick = async () => {
                                        const previousSlotData = slotsData;
                                        const updatedDocumentData = {
                                          ...docData,
                                          document_slot: slot,
                                        };

                                        const matchingSlot = previousSlotData.find((slot) =>
                                          slot.page_docs?.some((doc) => doc.id === docData.id)
                                        );

                                        const panelWithDocument = matchingSlot?.panels?.find(
                                          (panel) =>
                                            panel.documents?.some((doc) => doc.id === docData?.id)
                                        );

                                        const updatedSlotsData = slotsData.map((currentSlot) => {
                                          if (currentSlot?.page?.id === matchingSlot?.page?.id) {
                                            const hasDocument = currentSlot.page_docs?.some(
                                              (doc) => doc.id === docData.id
                                            );

                                            const hasPanel = currentSlot.panels?.some((panel) =>
                                              panel.documents?.some((doc) => doc.id === docData.id)
                                            );

                                            if (hasPanel) {
                                              return {
                                                ...currentSlot,
                                                page_docs:
                                                  currentSlot.page_docs?.filter(
                                                    (doc) => doc.id !== docData.id
                                                  ) || [],
                                                panels:
                                                  currentSlot.panels?.map((panel) => {
                                                    if (panel.id === panelWithDocument?.id) {
                                                      return {
                                                        ...panel,
                                                        documents: [
                                                          ...(panel.documents?.filter(
                                                            (doc) => doc.id !== docData.id
                                                          ) || []),
                                                        ],
                                                      };
                                                    }
                                                    return panel;
                                                  }) || [],
                                              };
                                            } else if (hasDocument) {
                                              const filteredDocs = currentSlot.page_docs.filter(
                                                (doc) => doc.id !== docData.id
                                              );

                                              return {
                                                ...currentSlot,
                                                page_docs: filteredDocs,
                                              };
                                            }
                                          }

                                          return currentSlot;
                                        });

                                        const updatingSlot = updatedSlotsData.map((currentSlot) => {
                                          if (currentSlot?.page?.id === slot?.page?.id) {
                                            return {
                                              ...currentSlot,
                                              page_docs: currentSlot.page_docs
                                                ? [...currentSlot.page_docs, updatedDocumentData]
                                                : [updatedDocumentData],
                                            };
                                          }

                                          return currentSlot;
                                        });

                                        try {
                                          const formData = new FormData();
                                          formData.append("case_id", caseId);
                                          formData.append("client_id", clientId);
                                          formData.append("court_form_id", courtFormId);
                                          formData.append(
                                            "context",
                                            JSON.stringify(formDataContext)
                                          );

                                          const response = await api_without_cancellation.post(
                                            "api/court-form/generate-courtform-pdf/",
                                            formData,
                                            {
                                              headers: {
                                                "Content-Type": "multipart/form-data",
                                              },
                                            }
                                          );

                                          if (response.data) {
                                            setSlotsData(updatingSlot);
                                            const result = await api_without_cancellation.post(
                                              "api/doc/attach/",
                                              {
                                                slot: slot.id,
                                                page_id: page.id,
                                                case_id: caseId,
                                                panels: false,
                                                doc_id: response?.data?.doc_id,
                                              }
                                            );
                                            if (result.data) {
                                              setAttachData(result.data.docData);
                                              setIsPDFModalOpen(true);
                                            }
                                            if (typeof refetchDocumentData === "function") {
                                              await refetchDocumentData();
                                            }
                                            onRefetchSlotsData();
                                          }
                                        } catch (error) {
                                          console.error(error);
                                          setSlotsData(previousSlotData);
                                        }
                                      };

                                      return (
                                        <li
                                          key={slotIndex}
                                          className="d-flex align-items-center"
                                          style={{
                                            height: "25px",
                                            cursor: docsInSlot.length > 0 ? "default" : "pointer",
                                            padding: "0px 10px",
                                          }}
                                          onClick={handleClick}
                                        >
                                          {slot.slot_number !== 0 && (
                                            <span className="d-flex align-items-center justify-content-center">
                                              {docsInSlot.length > 0 ? (
                                                <i
                                                  className="ic ic-19 ic-file-colored cursor-pointer document-icons-width"
                                                  style={{
                                                    backgroundRepeat: "no-repeat",
                                                  }}
                                                />
                                              ) : (
                                                <img
                                                  src={UploadIcon}
                                                  className="document-icons-width cursor-pointer"
                                                  style={{
                                                    backgroundRepeat: "no-repeat",
                                                  }}
                                                />
                                              )}
                                            </span>
                                          )}

                                          {/* {slot.slot_number === 0 && (
                                      <div
                                        className="d-flex align-items-center justify-content-center"
                                        style={{
                                          width: "100%",
                                        }}
                                      >
                                        <span
                                          className="d-flex align-items-center whitespace-nowrap "
                                          style={{ fontWeight: "bold" }}
                                        >
                                        
                                          Attach to {page.name} Page
                                        </span>
                                      </div>
                                    )} */}

                                          {slot.slot_number !== 0 && (
                                            <div
                                              className={`d-flex align-items-center  ${
                                                docsInSlot.length === 0
                                                  ? "color-grey-2 hoverable-text"
                                                  : ""
                                              }`}
                                              style={{
                                                width: "calc(100% - 25px)",
                                                fontWeight: "bold",
                                              }}
                                            >
                                              <>
                                                <span className="ms-2 hoverable-text">
                                                  {slot.slot_number}.
                                                </span>
                                                <span className="ms-2 hoverable-text whitespace-nowrap">
                                                  {docsInSlot.length > 0
                                                    ? docsInSlot[0].file_name
                                                    : slot.slot_name
                                                      ? slot.slot_name
                                                      : "Available"}
                                                </span>
                                              </>
                                            </div>
                                          )}
                                        </li>
                                      );
                                    })}
                                </ul>
                              </li>
                            );
                          }
                        }

                        return null;
                      })}

                    {pages?.length === 0 &&
                      [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14].map((index) => (
                        <li key={index} className="">
                          <a
                            className="cursor-pointer d-flex align-items-center justify-content-center shimmer-effect relative overflow-hidden"
                            style={{
                              height: "21px",
                              backgroundColor:
                                index % 2 === 0 ? "var(--primary-2)" : "var(--primary-4)",
                            }}
                          >
                            <div
                              className="absolute inset-0"
                              style={{
                                animation: "shimmer 2s infinite linear",
                                background:
                                  "linear-gradient(90deg, transparent 0%, rgba(255, 255, 255, 0.3) 50%, transparent 100%)",
                                backgroundSize: "1000px 100%",
                              }}
                            >
                              {index === 7 && (
                                <span
                                  style={{
                                    color: "var(--primary-50)",
                                    fontSize: "14px",
                                    fontWeight: "600",
                                  }}
                                >
                                  Attach Document To Case First
                                </span>
                              )}
                            </div>
                          </a>
                        </li>
                      ))}
                  </ul>
                )}
              </div>
              {/* Hover End */}
            </div>
            {/* <div
              className="document-sidebar-actions d-flex flex-column"
              style={{ gap: height <= 1024 ? "8px" : "40px" }}
            >
              <div
                className="generate-court-form-primary-actions"
                style={{
                  display: "flex",
                  flexDirection: height <= 1024 ? "row" : "column",
                  justifyContent: height <= 1024 ? "space-between" : "initial",
                  background: "white",
                  padding: "5px",
                  gap: "5px",
                }}
              >

                <div className="tile-row w-100 m-b-5  center-content my-auto">
                  <div className="dropdown  d-flex" ref={dropdownRefs.chatDoc}>
                    <button
                      className={`btn height-25 bottom-sidebar-buttons-things  dropdown-toggle position-relative d-flex align-items-center justify-content-center w-100 form-select has-no-bg position-relative doc-rev-btn rotate-btn ${dropdownOpen.chatDoc ? "show" : ""}`}
                      type="button"
                      // onClick={() => toggleDropdown("chatDoc")}
                      onClick={handleShow}
                      aria-haspopup="true"
                      aria-expanded={dropdownOpen.chatDoc}
                    >
                     
                      <span className="ic-15 d-flex align-items-center justify-content-center">
                        <i className="ic ic-15 ic-chat-3d d-flex align-items-cente justify-content-center" />
                      </span>
                      {height <= 1024 ? "" : "Send Document Link by Chat"}
                    </button>
                   
                  </div>
                </div>

                <div className="tile-row w-100 m-b-5  center-content my-auto">
                  <div className="dropdown d-flex" ref={dropdownRefs.taskLink}>
                    <button
                      className={`btn height-25 bottom-sidebar-buttons-things  dropdown-toggle position-relative d-flex align-items-center justify-content-center w-100 form-select has-no-bg position-relative doc-rev-btn rotate-btn ${dropdownOpen.taskLink ? "show" : ""}`}
                      type="button"
                      // onClick={() => toggleDropdown("taskLink")}
                      onClick={handShowDocLinkModal}
                    >
                     
                      <span className="ic-15 d-flex align-items-center justify-content-center">
                        <i className="ic ic-15 ic-file-colored cursor-pointer d-flex align-items-center justify-content-center" />
                      </span>
                      {height <= 1024 ? "" : "Link Document to Task"}
                    </button>
                   
                  </div>
                </div>

                <div className="tile-row w-100 m-b-5 center-content my-auto">
                  <div className="dropdown d-flex" ref={dropdownRefs.docReview}>
                    <button
                      className={`btn height-25 bottom-sidebar-buttons-things  dropdown-toggle position-relative d-flex align-items-center justify-content-center w-100 form-select has-no-bg position-relative doc-rev-btn rotate-btn ${dropdownOpen.docReview ? "show" : ""}`}
                      type="button"
                      onClick={toggleModal}
                      aria-haspopup="true"
                      aria-expanded={dropdownOpen.docReview}
                    >
                      
                      <span className="ic-15 d-flex align-items-center justify-content-center">
                        <img
                          src="https://simplefirm-bucket.s3.amazonaws.com/static/images/to-do-icon-color_PyU3ldW.svg"
                          alt="Request document review"
                          className="ic ic-15 cursor-pointer d-flex align-items-center justify-content-center"
                        />
                      </span>

                      {height <= 1024 ? "" : "Request Document Review Task"}
                    </button>
                  </div>
                </div>
              </div>
            </div> */}
          </div>
        </div>
      </div>
      <div style={{ position: "relative", top: "5px" }}>
        <CourtFormPageSideMenu
          litigationId={litigationId}
          docId={""}
          fetchEditDocs={fetchEditDocs}
          // dispatch={dispatch}
          type={"type"}
          container={"container"}
          docName={docName}
          state={"state"}
          courtFormId={courtFormId}
          formDataContext={formDataContext}
          openCourtForm={openCourtForm}
          showPdf={showPdf}
          setShowPdf={setShowPdf}
          isSaveDisabled={isSaveDisabled}
        />
      </div>
      <RequestDocModal
        selectedDoc={docSideId}
        isOpen={isModalOpen}
        caseInfo={caseInfo}
        onConfirm={toggleModal}
        onClose={toggleModal}
        container={container}
        docName={docName}
      />
      <LinkDocToTaskModal
        showModal={showDocLinkModal}
        handleClose={handleShowDocLinkModalClose}
        userId={userId} //
        caseId={caseId}
        docId={docSideId}
        clientId={clientId} //
        container={container}
        docName={docName}
      />
      <ChatDocumentModal
        showModal={showModal}
        caseId={caseId}
        userId={userId}
        caseInfo={caseInfo}
        clientId={clientId}
        handleClose={handleClose}
        docId={docSideId}
        docName={docName}
        container={container}
      />

      {isPDFModalOpen && attachData && (
        <PdfConfirmationModal
          isPDFModalOpen={isPDFModalOpen}
          redirectToFirmSetting={redirectToFirmSetting}
          countdown={countdown}
          attachData={attachData}
          togglePDFModal={togglePDFModal}
        />
      )}
    </div>
  );
};

GenerateCourtFormModalSideBar.propTypes = {
  documentData: PropTypes.shape({
    id: PropTypes.number,
    for_client: PropTypes.object,
    for_case: PropTypes.shape({
      case_type: PropTypes.shape({
        name: PropTypes.string,
        casetype_icon: PropTypes.string,
      }),
      incident_date: PropTypes.string,
    }),
    file_name: PropTypes.string,
    docDate: PropTypes.string,
    attached_by: PropTypes.shape({
      first_name: PropTypes.string,
      last_name: PropTypes.string,
      profile_pic_29p: PropTypes.string,
    }),
    document_slot: PropTypes.object,
  }).isRequired,
  pages: PropTypes.array.isRequired,
  slotsData: PropTypes.array.isRequired,
};

export default GenerateCourtFormModalSideBar;
